//Generated file - DO NOT MODIFY
import { observable, computed, action } from 'mobx';
import { serializable, identifier, update, deserialize } from 'serializr';
import _ from 'lodash';

export default class TcFileBase {
    @serializable @observable tcFileId = '';
    @serializable @observable title = '';
    @serializable @observable propertyAddress = '';
    @serializable @observable typeOfSale = '';
    @serializable @observable propertyType = "";
    @serializable @observable status = '';
    @serializable @observable origin = '';
    @serializable @observable fileSubmissionDate = '';
    @serializable @observable estimatedCloseDate = '';
    @serializable @observable actualCloseDate = '';
    @serializable @observable daysInEscrow = '';
    @serializable @observable survey = '';
    @serializable @observable hud = '';
    @serializable @observable thumbDrive = '';
    @serializable @observable coordinatorId = '';
    @serializable @observable subscriberName = '';
    @serializable @observable notes = '';
    @serializable @observable checkStatus = '';
    @serializable @observable checkNumber = '';
    @serializable @observable checkAmount = '';
    @serializable @observable depositDate = '';
    @serializable @observable originId = '';
    @serializable @observable subscriberId = '';
    @serializable @observable transactionId = '';
    @serializable @observable address1 = '';
    @serializable @observable address2 = '';
    @serializable @observable city = '';
    @serializable @observable state = '';
    @serializable @observable county = '';
    @serializable @observable zip = '';
    @serializable @observable direction = '';
    @serializable @observable unitNum = '';
    @serializable @observable originatedFromListing = '';
    @serializable @observable expirationDate = '';
    
    static get __name__() {
        return 'TcFile';
    }

    constructor(
        tcFileId = '',
        title = '',
        propertyAddress = '',
        typeOfSale = '',
        status = '',
        origin = '',
        fileSubmissionDate = '',
        estimatedCloseDate = '',
        actualCloseDate = '',
        daysInEscrow = '',
        survey = '',
        hud = '',
        thumbDrive = '',
        coordinatorId = '',
        subscriberName = '',
        notes = '',
        checkStatus = '',
        checkNumber = '',
        checkAmount = '',
        depositDate = '',
        originId = '',
        subscriberId = '',
        transactionId = '',
        address1 = '',
        address2 = '',
        city = '',
        state = '',
        county = '',
        zip = '',
        direction = '',
        unitNum = '',
        originatedFromListing = '',
        expirationDate='',
        propertyType = '',
    ) {
        this.tcFileId = observable();
        this.tcFileId = tcFileId;
        this.title = observable();
        this.title = title;
        this.propertyAddress = observable();
        this.propertyAddress = propertyAddress;
        this.typeOfSale = observable();
        this.typeOfSale = typeOfSale;
        this.propertyType = observable();
        this.propertyType = propertyType;
        this.status = observable();
        this.status = status;
        this.origin = observable();
        this.origin = origin;
        this.fileSubmissionDate = observable();
        this.fileSubmissionDate = fileSubmissionDate;
        this.estimatedCloseDate = observable();
        this.estimatedCloseDate = estimatedCloseDate;
        this.actualCloseDate = observable();
        this.actualCloseDate = actualCloseDate;
        this.daysInEscrow = observable();
        this.daysInEscrow = daysInEscrow;
        this.survey = observable();
        this.survey = survey;
        this.hud = observable();
        this.hud = hud;
        this.thumbDrive = observable();
        this.thumbDrive = thumbDrive;
        this.coordinatorId = observable();
        this.coordinatorId = coordinatorId;
        this.subscriberName = observable();
        this.subscriberName = subscriberName;
        this.notes = observable();
        this.notes = notes;
        this.checkStatus = observable();
        this.checkStatus = checkStatus;
        this.checkNumber = observable();
        this.checkNumber = checkNumber;
        this.checkAmount = observable();
        this.checkAmount = checkAmount;
        this.depositDate = observable();
        this.depositDate = depositDate;
        this.originId = observable();
        this.originId = originId;
        this.subscriberId = observable();
        this.subscriberId = subscriberId;
        this.transactionId = observable();
        this.transactionId = transactionId;
        this.address1 = observable();
        this.address1 = address1;
        this.address2 = observable();
        this.address2 = address2;
        this.city = observable();
        this.city = city;
        this.state = observable();
        this.state = state;
        this.county = observable();
        this.county = county;
        this.zip = observable();
        this.zip = zip;
        this.direction = observable();
        this.direction = direction;
        this.unitNum = observable();
        this.unitNum = unitNum;
        this.originatedFromListing = observable();
        this.originatedFromListing = originatedFromListing;
        this.expirationDate = observable();
        this.expirationDate = expirationDate;
    }
}



// WEBPACK FOOTER //
// ./src/shared/tcfile-base.js